import { Button } from '@library/components/buttons';
import { DatePickerCustomInputContext } from '@library/components/datePicker/DatePickerCustomInput';
import type { ReactNode } from 'react';
import { useContext } from 'react';

export interface DatePickerButtonProps {
  className?: string;
  children: ReactNode;
  disabled?: boolean;
}

export const DatePickerButton = ({
  className = undefined,
  children,
  disabled = false
}: DatePickerButtonProps) => {
  const { onClick } = useContext(DatePickerCustomInputContext);

  return (
    <Button
      className={className}
      data-testid="date-picker-button"
      disabled={disabled}
      title="DatePickerButton"
      onClick={onClick}
      type="button"
    >
      {children}
    </Button>
  );
};
